import { render, staticRenderFns } from "./Players.page.vue?vue&type=template&id=6488499c&scoped=true"
import script from "./Players.page.vue?vue&type=script&lang=ts"
export * from "./Players.page.vue?vue&type=script&lang=ts"
import style0 from "./Players.page.vue?vue&type=style&index=0&id=6488499c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-load_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6488499c",
  null
  
)

export default component.exports